export class Config {
    static baseUrl = 'https://otlobcoach.com/api/v1'
    // static baseUrl = 'http://localhost:3000/api/v1'
    //auth
    static login = `${Config.baseUrl}/auth/login`
    static TrainerRegister = `${Config.baseUrl}/auth/trainerRegister`
    static TraineeRegister = `${Config.baseUrl}/auth/traineeRegister`
    static requestReset = `${Config.baseUrl}/auth/password/request-reset`
    static verifyOTP = `${Config.baseUrl}/auth/password/verify-otp`
    static resetPassword = `${Config.baseUrl}/auth/password/reset`
    static getAllRegisterCategory = `${Config.baseUrl}/category/getAllRegisterCategories`
    // home
    static getAllCategories = `${Config.baseUrl}/category/getAllCategories`
    static getAllLearningCategories = `${Config.baseUrl}/category/getAllLearningCategories`
    static getAllTrainers = `${Config.baseUrl}/trainer/allTrainers`
    static getTrainersSortedByRate = `${Config.baseUrl}/trainer/allTrainersSortedByRate`
    static getTrainersSortedByNumOfOrders = `${Config.baseUrl}/trainer/allTrainersSortedByNumOfOrders`
    //Chats
    static getAllChats = `${Config.baseUrl}/chat/getAllChats`
    static getChatById = `${Config.baseUrl}/chat/getChatById`
    static getChatByRecieverId = `${Config.baseUrl}/chat/getChat`
    static getChatBySenderReceiverId = `${Config.baseUrl}/chat/getChatBySenderReceiverIds`
    static sendMessage = `${Config.baseUrl}/chat/sendMessage`
    //profile
    static getAllEnrollmentsForATrainer = `${Config.baseUrl}/enrollment/getAllCoursesForTrainer`
    static getAllEnrollmentsForATrainee = `${Config.baseUrl}/enrollment/getAllCoursesForTrainee`
    static getAllEnrollmentsForATraineeById = `${Config.baseUrl}/enrollment/getAllCoursesForTraineeById`
    static addNewEnrollment = `${Config.baseUrl}/enrollment/newEnrollment`
    static getUserInfo = `${Config.baseUrl}/user/getUserInfo`
    static getUserInfoById = `${Config.baseUrl}/user/getUserInfoById`
    static updateProfileImage = `${Config.baseUrl}/auth/updateProfileImage`
    //contactUs
    static sendContactUs = `${Config.baseUrl}/contact-us/createContact`



    //?admin
    //!chat
    static getAllPendingMessages = `${Config.baseUrl}/chat/getAllPendingMessages`
    static acceptMessages = `${Config.baseUrl}/chat/acceptMessage`
    static rejectMessages = `${Config.baseUrl}/chat/rejectMessage`
    static editMessages = `${Config.baseUrl}/chat/editMessage`
    static getAllCHatsBYAdmin = `${Config.baseUrl}/chat/getAllChatsByAdmin`
    static sendMessageByAdmin = `${Config.baseUrl}/chat/sendMessageByAdmin`
    //!trainers
    static getAllPendingTrainers = `${Config.baseUrl}/trainer/allPendingTrainers`
    static acceptTrainer = `${Config.baseUrl}/trainer/acceptTrainer`
    static rejectTrainer = `${Config.baseUrl}/trainer/rejectTrainer`
    static editTrainer = `${Config.baseUrl}/trainer/updateTrainer`
    static BlockTrainer = `${Config.baseUrl}/user/triggerUserBlock`
    static downloadTrainers = `${Config.baseUrl}/user/getAllTrainersSheet`
    static getAllTrainersAdmin = `${Config.baseUrl}/user/getAllTrainers`
    static getAllUsers = `${Config.baseUrl}/user/getAllUsers`
    //!Category
    static addNewCategory = `${Config.baseUrl}/category/creatCategory`
    static addNewSubCategory = `${Config.baseUrl}/category/CreatSubCategory`
    static deleteCategory = `${Config.baseUrl}/category/deleteCategory`
    static deleteSubCategory = `${Config.baseUrl}/category/deleteSubCategory`
    //!admin
    static addNewAdmin = `${Config.baseUrl}/auth/adminRegister`
    static getAllAdmins = `${Config.baseUrl}/user/getAllAdmins`
    //!enrollments
    static getAllPendingenrollments = `${Config.baseUrl}/enrollment/getAllPendingEnrollments`
    static getAllOpenedenrollments = `${Config.baseUrl}/enrollment/getAllOpeningEnrollments`
    static getAllClosedenrollments = `${Config.baseUrl}/enrollment/getAllClosedEnrollments`
    static updateenrollmentsPrice = `${Config.baseUrl}/enrollment/updatePrice`
    static updateenrollmentsRate = `${Config.baseUrl}/enrollment/updateRate`
    static updateenrollmentsStatus = `${Config.baseUrl}/enrollment/updateStatus`
    static downloadEnrollments = `${Config.baseUrl}/enrollment/extractEnrollmentsFile`
    //!tranees
    static getAllTrainees = `${Config.baseUrl}/user/getAllTrainees`
    static downloadTrainees = `${Config.baseUrl}/user/getAllTraineesSheet`
    static UpdateTrainee = `${Config.baseUrl}/trainer/updateTrainee`
    static updateTrainerProfileImage = `${Config.baseUrl}/auth/updateTrainerProfileImage`

    //!contacts
    static getAllContacts = `${Config.baseUrl}/contact-us/getAllContacts`
}